import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './comps/home/home.component';
import { PrivacyComponent } from './comps/privacy/privacy.component';
import { TermComponent } from './comps/term/term.component';
import { MsaComponent } from './comps/msa/msa.component';
import { PartnerAgreementComponent } from './comps/partner-agreement/partner-agreement.component';
import { PageNotFoundComponent } from './comps/page-not-found/page-not-found.component';
import { BecomePartnerComponent } from './comps/become-partner/become-partner.component';

const routes: Routes = [
  { path: '', component: HomeComponent, title: 'Chareety \u2014 Free Nonprofit Donation Platform | Accept Donations In Person & Online' },
  { path: 'privacy', component: PrivacyComponent, title: 'Privacy Policy \u2014 Chareety' },
  { path: 'terms', component: TermComponent, title: 'Terms of Service \u2014 Chareety' },
  { path: 'term', redirectTo: 'terms', pathMatch: 'full' },
  { path: 'msa', component: MsaComponent, title: 'Master Service Agreement \u2014 Chareety' },
  { path: 'legal/organization-service-agreement', component: MsaComponent, title: 'Master Service Agreement \u2014 Chareety' },
  { path: 'partner-agreement', component: PartnerAgreementComponent, title: 'Partner Agreement \u2014 Chareety' },
  { path: 'legal/partner-referral-agreement', component: PartnerAgreementComponent, title: 'Partner Agreement \u2014 Chareety' },
  { path: 'become-partner', component: BecomePartnerComponent, title: 'Become a Sales Partner \u2014 Chareety' },
  { path: '**', component: PageNotFoundComponent, title: 'Page Not Found \u2014 Chareety' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
